import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { Connector } from "../../../../http/deckDesigner/types/connectors";
import useDeckConnectorsApi from "../../../../http/deckDesigner/useConnectors";
import ConnectorForm from "./ConnectorForm";
import { getItemOptionLabel } from "../../../../hooks/useItemOptions";

const AdminConnectors: FC = () => {
  const i18n = useI18n();
  const connectorsApi = useDeckConnectorsApi();
  const unitMm = i18n.translation.common.unitMm;

  return (
    <AdminCrudTable<Connector>
      filterPrefix="connectors"
      useList={connectorsApi.useDeckConnectors}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.code}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.description}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.connectorFamilies.singular}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.connectorMaterials.singular}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.thickness}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.connectors.minGroovingHeight}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.connectors.minBoardWidth}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.screws.singular}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.item.code}</TableCell>
          <TableCell>{item.item.description}</TableCell>
          <TableCell>{item.connectorFamily.name}</TableCell>
          <TableCell>{item.connectorMaterial.name}</TableCell>
          <TableCell>
            {item.thickness} {unitMm}
          </TableCell>
          <TableCell>{item.minGroovingHeight != null && `${item.minGroovingHeight} ${unitMm}`}</TableCell>
          <TableCell>{item.minBoardWidth != null && `${item.minBoardWidth} ${unitMm}`}</TableCell>
          <TableCell>{item.screw ? getItemOptionLabel(item.screw.item) : ""}</TableCell>
        </>
      )}
      visibilityAndOrder={{
        updateVisibility: (item, visibility) =>
          connectorsApi.updateDeckConnectorVisibility(item.item.id, { visibility }),
        updateOrder: (item, order) => connectorsApi.updateDeckConnectorOrder(item.item.id, { order }),
      }}
      onDelete={(item) => connectorsApi.deleteDeckConnector(item.item.id)}
      deleteTitle={i18n.translation.deckDesignerModule.connectors.singular}
      canAdd
      renderForm={(item, onClose) => <ConnectorForm connector={item} onClose={onClose} />}
    />
  );
};

export default AdminConnectors;
